export default "data:image/webp;base64,UklGRkIAAABXRUJQVlA4IDYAAACwAQCdASoFAAYAAgA0JQBOgCHXYLHAAP63eWfwndjbdxgIzdcWILa0FfUqRNl204PXwZw8oAA="